<template>
  <el-autocomplete
    class="inline-input"
    v-model="searchQuery"
    :fetch-suggestions="fetchSuggestions"
    placeholder="Product Name"
    @select="navigateProduct"
    :debounce="500"
    :highlight-first-item="true"
  >
    <i class="el-icon-search" slot="prefix"></i>
  </el-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SearchComponent",
  data() {
    return {
      links: [],
      allowed: false,
      isSearchVisible: true,
      loading: false,
      searchQuery: ""
    };
  },
  computed: {
    ...mapGetters("products", ["getProductNames"])
  },
  methods: {
    async fetchSuggestions(query, callBack) {
      await this.$store.dispatch("products/searchByQuery", {
        search_query: query
      });
      if (this.getProductNames) {
        let productNames = this.getProductNames;
        window.names = productNames;
        let results = [];
        productNames.filter(item => {
          results.push({ value: item.name, link: item.slug });
        });
        callBack(results);
      }
    },
    navigateProduct({ link }) {
      this.searchQuery = "";
      this.$router.push({
        name: "product-details",
        params: { slug: link }
      });
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    }
  }
};
</script>

<style lang="scss">
.inline-input {
  width: 98%;
}
.card-icons-list {
  .el-input__prefix {
    top: 14px !important;
    left: 10px;
  }
}
.search-filter-box {
  width: 220px;
  position: absolute;
  right: 35px;
  display: none;
  .el-autocomplete {
    width: 250px;
    .el-input__inner {
      width: 250px;
    }
  }
  .el-input__prefix,
  .el-input__suffix {
    top: 14px !important;
  }
}
.el-autocomplete-suggestion {
  width: 250px !important;
  z-index: 12001 !important;
}

.sticky .search-filter-box {
  display: block;
}
</style>
